import BaseComponent from "../../../../../lib/components/BaseComponent";
import Modal from "../../../../../appl/view/components/Modal";

class DialogsTest extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      mydialog: null
    }
  }

  test(event) {
    this.state.mydialog = <Modal />
    this.setState(this.state);
  }

  render() {
    return <div className='sandbox-container flex flex-col gap-4'>
      <h1>Dialog test</h1>
      <button onClick={(event) => this.test(event)}>
        test
      </button>
      <div>
        {this.state.mydialog}
      </div>
    </div>
  }
}

export default DialogsTest;
